import { datadogLogs } from "@datadog/browser-logs";
import Avvir, { HxAuthUser, isHxAuthUser, ResponseError } from "avvir";

import getUser from "../../../services/getters/base_getters/get_user";
import signOutUser from "../../sign_in_page/sign_out_user";
import toHxAuthLoginPage from "../../../events/routing/to_hx_auth_login_page";
import userAccountLoaded, { UserAccountLoadedEvent } from "../../../events/auth_events/user_account_loaded";
import { ApiFailureEvent } from "../../../events/notifications/failure_notifications/api_failure";
import { AvvirAsyncThunk } from "../../make_eventful_action";
import { decodeAvvirGatewayToken } from "../../../services/firebase_services/firebase_tokens";

const isAuthRejection = (error: unknown): boolean => {
  return error instanceof ResponseError && (error.status === 401 || error.status === 403);
};

function loadUserAccount(): AvvirAsyncThunk<typeof getUser, UserAccountLoadedEvent | ApiFailureEvent> {
  return (dispatch, getState) => {
    const user = getUser(getState(), {});
    return Avvir.api.user.getUserAccount(user)
      .then((account) => {
        datadogLogs.addLoggerGlobalContext("user_id", account.userId);
        dispatch(userAccountLoaded(account));
        return getUser(getState(), {});
      })
      .catch((error) => {
        if (!isAuthRejection(error)) {
          console.error("Failed to load user account; leaving session intact", error);
          return getUser(getState(), {});
        }
        if (isHxAuthUser(user)) {
          const accessToken = (user as HxAuthUser).hxAuthUser.accessToken;
          const jwtContents = decodeAvvirGatewayToken(accessToken);
          return signOutUser(toHxAuthLoginPage({
            error: "no-matching-user",
            uuid: jwtContents.sub,
          }))(dispatch, getState).then(() => null);
        } else {
          return signOutUser()(dispatch, getState).then(() => null);
        }
      });
  };
}

export default loadUserAccount;
